export default "__VITE_ASSET__Ct19l_i9__"